import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  return (
    <section className="border-y border-background-200 bg-background-100/60 py-12 md:py-16">
      <div className="container-x grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-start">
        <div>
          <p className="text-xs font-medium tracking-widest text-primary-600">常见问题</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">追更前先看这里</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-500">
            关于作品类型、宗门篇剧情、境界划分、剧透提示与投稿方式，最常见的问题都整理好了。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-300 bg-primary-50 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            查看全部常见问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <FaqAccordion items={faqs.slice(0, 4)} />
      </div>
    </section>
  );
}